// ANNONCE CONSTANTS
export const REQUEST_LIST_PLAN ="REQUEST_LIST_PLAN"
export const SUCCESS_LIST_PLAN ="SUCCESS_LIST_PLAN"
export const FAIL_LIST_PLAN ="FAIL_LIST_PLAN"
// UPGRADE PLAN CONST
export const REQUEST_UPGRADE_PLAN ="REQUEST_UPGRADE_PLAN"
export const SUCCESS_UPGRADE_PLAN ="SUCCESS_UPGRADE_PLAN"
export const FAIL_UPGRADE_PLAN ="FAIL_UPGRADE_PLAN"

